var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('iframe',{attrs:{"id":"iframe_home","src":_vm.src,"width":"380px","height":"675px"}}),_c('iframe',{staticStyle:{"flex":"1"},attrs:{"src":_vm.adSrc,"height":"675px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }